export { default } from "./SectionHeading.jsx";
